import React from 'react';
import { Grid } from '@mantine/core';
import Spinner from './Spinner';

// The modal below is this form's own approximation of the one the SDK builds on
// the shop, for the previews that render the block's markup on its own. A
// preview that renders through the SDK brings the real modal with it and passes
// `withChrome={false}`, so it is not wrapped in a second one.
const PageBlockPreview = ({ block, preview, withChrome = true }) => {
  if (!block) {
    return <Spinner />;
  }

  const modalBannerDisplay = block.displayType === 'popup' ? 'flex' : 'block';

  const overlayColor = block.cssStyles?.overlayColor || 'transparent';

  const previewTempStyles = {
    backgroundColor: '#fefefe',
    border: '1px solid #888',
    position: 'relative',
    width: block.displayType === 'popup' ? '40%' : '100%',
    bottom: block.displayType === 'bar' ? (block.displayPosition === 'bottom' ? '-237px' : '0') : 0,
    right: block.displayType === 'flyout' && block.displayPosition === 'right' ? '30px' : 'unset',
    left: block.displayType === 'flyout' && block.displayPosition === 'left' ? '30px' : 'unset',
    margin: block.displayType === 'flyout' ? '0' : 'auto',
  };

  // No zoom: the preview scales itself to fit the column it lands in.
  const inner = <div style={{ pointerEvents: 'none' }}>{preview}</div>;

  return !withChrome || block.displayType === 'static' || block.displayType === 'custom' ? (
    inner
  ) : (
    <Grid>
      <Grid.Col span={12}>
        <div className="previewHolder banner">
          <div
            id="banner-modal"
            className="modalBanner"
            style={{
              zIndex: 1000,
              width: '100%',
              height: '500px',
              overflow: 'hidden',
              backgroundColor: overlayColor,
              display: modalBannerDisplay,
              justifyContent: 'center',
            }}
          >
            <div className="BannerModalContent" style={previewTempStyles}>
              <div
                className="closeBtnHolder"
                style={{
                  position: 'absolute',
                  top: `${block.cssStyles.closeButtonTopPosition}px`,
                  right: `${block.cssStyles.closeButtonRightPosition}px`,
                  lineHeight: `${block.cssStyles.closeButtonLineHeight}px`,
                }}
              >
                <div id="banner-close" style={{ cursor: 'pointer', zIndex: 9999 }}>
                  <h3
                    style={{
                      border: block.cssStyles.closeButtonBorder,
                      color: block.cssStyles.closeButtonColor,
                      fontSize: `${block.cssStyles.closeFontSize}px`,
                      margin: 0,
                      backgroundColor: block.cssStyles.closeButtonBackgroundColor,
                      borderRadius: `${block.cssStyles.closeButtonBorderRadius}px`,
                      padding: block.cssStyles.closeButtonPadding,
                      fontFamily: 'inherit',
                      lineHeight: `${block.cssStyles.closeButtonLineHeight}px`,
                      fontWeight: block.cssStyles.closeButtonFontWeight,
                    }}
                  >
                    &nbsp;{block.cssStyles.closeButtonSymbol}&nbsp;
                  </h3>
                </div>
              </div>
              <div style={{ padding: '20px', textAlign: 'center' }}>{inner}</div>
            </div>
          </div>
        </div>
      </Grid.Col>
    </Grid>
  );
};

export default PageBlockPreview;
